import * as React from 'react';

import { Button } from '@coursera/cds-core';

type Props = {
  link?: string | null;
  text?: string | null;
};

const ConsumerHeroCTA: React.FC<Props> = ({ link, text }) => {
  if (!link) return null;

  return (
    <Button component="a" variant="primary" href={link}>
      {text}
    </Button>
  );
};

export default ConsumerHeroCTA;
